/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LegalDocumentsDto
 */
export interface LegalDocumentsDto {
    /**
     * URL to the privacy policy PDF document
     * @type {string}
     * @memberof LegalDocumentsDto
     */
    privacyPolicy: string;
    /**
     * URL to the terms and conditions PDF document
     * @type {string}
     * @memberof LegalDocumentsDto
     */
    tnc: string;
    /**
     * URL to the disclaimer PDF document
     * @type {string}
     * @memberof LegalDocumentsDto
     */
    disclaimer: string;
}

/**
 * Check if a given object implements the LegalDocumentsDto interface.
 */
export function instanceOfLegalDocumentsDto(value: object): value is LegalDocumentsDto {
    if (!('privacyPolicy' in value) || value['privacyPolicy'] === undefined) return false;
    if (!('tnc' in value) || value['tnc'] === undefined) return false;
    if (!('disclaimer' in value) || value['disclaimer'] === undefined) return false;
    return true;
}

export function LegalDocumentsDtoFromJSON(json: any): LegalDocumentsDto {
    return LegalDocumentsDtoFromJSONTyped(json, false);
}

export function LegalDocumentsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LegalDocumentsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'privacyPolicy': json['privacyPolicy'],
        'tnc': json['tnc'],
        'disclaimer': json['disclaimer'],
    };
}

export function LegalDocumentsDtoToJSON(json: any): LegalDocumentsDto {
    return LegalDocumentsDtoToJSONTyped(json, false);
}

export function LegalDocumentsDtoToJSONTyped(value?: LegalDocumentsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'privacyPolicy': value['privacyPolicy'],
        'tnc': value['tnc'],
        'disclaimer': value['disclaimer'],
    };
}

